import "@fontsource/playfair-display";
import "@fontsource/playfair-display/700.css";
import "@fontsource/playfair-display/700-italic.css";
import "@fontsource/montserrat";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";

import "./App.css";
import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";

import { NavBar } from "./Components/NavBar/NavBar";
import AgeGate from "./Components/AgeGate/AgeGate";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";

// Pages
import Home from "./pages/Home/Home";
import Entertainers from "./pages/Entertainers/Entertainers";
import Services from "./pages/Services/Services";
import BookNow from "./pages/BookNow/BookNow";
import About from "./pages/About/About";
import Hiring from "./pages/Hiring/Hiring";
import Calgary from "./pages/Calgary/Calgary";
import Profile from "./pages/Profile/Profile";
import Login from "./pages/Login/Login";
import Join from "./pages/Join/Join";
import Inspirations from "./pages/Inspirations/Inspirations";

// Legal
import PrivacyPolicy from "./pages/Legal/PrivacyPolicy";
import TermsOfService from "./pages/Legal/TermsOfService";

// Blog (kept for later)
import BlogList from "./pages/Blog/BlogList";
import BlogPost from "./pages/Blog/BlogPost";
import BlogNew from "./pages/Blog/BlogNew";
import BlogEdit from "./pages/Blog/BlogEdit";
import BlogManage from "./pages/Blog/BlogManage";

// Admin (kept for later)
import Admin from "./pages/Admin/Admin";

import siteConfig from "./config/site";

function App() {
  useEffect(() => {
    import("flowbite");
  }, []);

  return (
    <AgeGate>
      <div className="App">
        <ScrollToTop />
        <NavBar />

        <Routes>
          {/* Main Pages */}
          <Route exact path="/" element={<Home />} />
          <Route path="/entertainers" element={<Entertainers />} />
          <Route path="/services" element={<Services />} />
          <Route path="/book" element={<BookNow />} />
          <Route path="/about" element={<About />} />
          <Route path="/hiring" element={<Hiring />} />
          <Route path="/calgary" element={<Calgary />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/join" element={<Join />} />
          <Route path="/inspirations" element={<Inspirations />} />

          {/* Legal */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />

          {/* Blog (for later) */}
          {siteConfig.features.blog && (
            <>
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/new" element={<BlogNew />} />
              <Route path="/blog/manage" element={<BlogManage />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/blog/:id/edit" element={<BlogEdit />} />
            </>
          )}

          {/* Admin (kept for later) */}
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </div>
    </AgeGate>
  );
}

export default App;
